import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchasingPerformance, setDefaultOfForm, fetchPurchasingPerformanceByProduct, setDefaultSearchType, setAllProducts, resetAllProducts, fetchPurchaseOrderList, changeFormValue } from '../../actions/purchaseOrders_actions';
import { fetchVendors } from '../../actions/vendors_actions';
import PurchasingPerformance from '../../components/Purchase/purchasingPerformance';
import PurchasingPerformanceNew from '../../components/Purchase/purchasingPerformanceNew';
import { fetchProductInfo, fetchSimplifiedProducts, fetchDeps, fetchDepsSuccess, fetchDepCategories, fetchGroupCategories, fetchPurchaser } from '../../actions/products_actions';
import { fetchSalesPerformanceByFilter } from '../../actions/salesPerformanceList_actions';
import { fetchPurchasePerformanceByFilter } from '../../actions/purchasingPerformanceList_actions';
import { fetchPurchasePerformanceByFilterGFD } from '../../actions/purchasingPerformanceList_actions';
import { isGFD } from '../../actions/root_url';

let purchasingPerformance = reduxForm({
  form: 'purchasingPerformance',
})(isGFD ? PurchasingPerformanceNew : PurchasingPerformance);

const selector = formValueSelector('purchasingPerformance');

function mapStateToProps(state) {
    const Days = selector(state, 'Days');
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');
    const POStatus = selector(state, 'POStatus');
    const Vendor_id = selector(state, 'Vendor_id');
    const purchaser_id = selector(state, 'purchaser_id');
    const BuyerId = selector(state, 'BuyerId');
    const searchType = selector(state, 'searchType');
    const allProducts = selector(state, 'AllProducts');
    const Product_id = selector(state, 'Product_id');

    return {
        Days,
        fromDate,
        toDate,
        POStatus,
        Vendor_id,
        purchaser_id,
        searchType,
        allProducts,
        Product_id,
        deps: state.products.deps,
        BuyerId,
        purchaserList: state.products.purchaserList,
        groups: state.products.groups,
        groupCategories: state.products.groupCategories,
        vendors: state.vendors.all,
        purchasingPerformanceIsLoading: state.purchaseOrders.purchasingPerformanceIsLoading,
        purchasingPerformance: state.purchaseOrders.purchasingPerformance,
        purchasingPerformanceByProducts: state.purchaseOrders.purchasingPerformanceByProducts,
        purchasingPerformanceError: state.purchaseOrders.purchasingPerformanceError,
        purchaseOrderPerformanceByProductIsLoading: state.purchaseOrders.purchaseOrderPerformanceByProductIsLoading,
        purchaseOrderPerformanceByProduct: state.purchaseOrders.purchaseOrderPerformanceByProduct,
        purchaseOrderPerformanceByProductError: state.purchaseOrders.purchaseOrderPerformanceByProductError,

        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,

        productInfo: state.products.productInfo,
        productInfoIsLoading: state.products.productInfoIsLoading,
        productInfoError: state.products.productInfoError,

        purchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
        purchaseOrderDetailIsLoading: state.purchaseOrders.detailIsLoading,
        purchaseOrderDetailError: state.purchaseOrders.detailError,

        purchaseOrderList: state.purchaseOrders.purchaseOrderList,
        purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
        purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,

        selectedWarehouse: state.header.selectedWarehouse,
        selectedCompany: state.header.selectedCompany,
    };
}

export default connect(mapStateToProps, {
  fetchPurchasePerformanceByFilter, fetchPurchasePerformanceByFilterGFD, fetchPurchasingPerformance, setDefaultOfForm,
  fetchVendors, fetchPurchasingPerformanceByProduct, setDefaultSearchType,setAllProducts, resetAllProducts,
  fetchPurchaseOrderList, fetchProductInfo, fetchSimplifiedProducts, changeFormValue, fetchDeps, fetchDepsSuccess, fetchSalesPerformanceByFilter, fetchDepCategories, fetchGroupCategories, fetchPurchaser })(purchasingPerformance);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasingPerformance.jsx